import Repository from "./Repository";

export default {
  deleteSchoolAdminContract(docId) {
    return Repository.delete(`school-admin/delete/${docId}`);
  },
};
